/**
 * The ONE duration formatter. Durations are carried as whole SECONDS (never
 * as decimal hours, whose floating point drifts) and shown as hours + minutes:
 *   9000 s -> "2 h 30 m", 3600 s -> "1 h 0 m", 1800 s -> "0 h 30 m", 11700 s -> "3 h 15 m".
 * Rounded to the nearest minute (a 1:59 timer entry reads "0 h 2 m").
 */
export function formatDuration(totalSeconds: number): string {
  const totalMinutes = Math.round(Math.max(0, Number.isFinite(totalSeconds) ? totalSeconds : 0) / 60);
  return `${Math.floor(totalMinutes / 60)} h ${totalMinutes % 60} m`;
}

/** A running clock, "HH:MM:SS". */
export function formatClock(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
}
